

































import { Component, Prop, Vue } from "vue-property-decorator";
import CzAccordion from "../cz/CzAccordion.vue";
import CzTag from "../cz/CzTag.vue";
import ProgramColumnRows from "./ProgramColumnRows.vue";

@Component({
  components: { CzAccordion, CzTag, ProgramColumnRows },
})
export default class ProgramColumns extends Vue {
  @Prop({ type: Array, default: () => [] }) columns!: any[];
  @Prop({ type: Number, default: 3 }) max!: number;
  @Prop({ type: Array, default: () => [] }) extras!: string[];
  @Prop({ type: Number, default: 0 }) busyId!: number;
  @Prop({ type: Number, default: -1 }) current!: number;

  open: boolean = false;
  opened: { [index: number]: boolean } = {};

  isOpen(index: number): boolean {
    return index in this.opened ? this.opened[index] : index === this.current;
  }

  toggle(index: number) {
    this.$set(this.opened, index, !this.isOpen(index));
  }

  get shown() {
    return this.open ? this.columns : this.columns.slice(0, this.max);
  }

  get moreLabel() {
    const rest = this.columns.length - this.max;
    return rest === 1
      ? this.$t("See the remaining one").toString()
      : this.$t("See the {0} remaining").toString().replace("{0}", String(rest));
  }
}
